module.exports = __webpack_public_path__ + "static/GalaxieCopernicus-SemiboldItalic-3e5a98a953486c6cc68199f59a6357fc.woff";